import { render } from "./TriageMedicalHistoryPage.vue?vue&type=template&id=04aae7ff"
import script from "./TriageMedicalHistoryPage.vue?vue&type=script&lang=js"
export * from "./TriageMedicalHistoryPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__